import { SubscriptionChannel } from './subscriptionChannel';
import { User } from './user';

export interface TenantSettings {
    agentHandleExtensionActivity?: boolean;
    billContactEmail?: string;
    billContactName?: string;
    billContactTitle?: string;
    blockedStatus?: boolean;
    brandEnabled?: boolean;
    brandHex?: string;
    brandLogo?: string;
    brandName?: string;
    city?: string;
    cw_clientId?: string;
    enableAuvikSupportAccess?: boolean;
    hideInternal?: boolean;
    hidePersonalEmail?: boolean;
    hubType?: string;
    name?: string;
    noSaaslioBrand?: boolean;
    phone?: string;
    qbrToCBR?: boolean;
    saasOps?: boolean;
    security_logging?: boolean;
    state?: string;
    streetAddress?: string;
    trialCustomer?: string;
    trialEndDate?: string | Date;
    userTracking?: boolean;
    zip?: string;
}

export enum Region {
    US = 'us',
    EU = 'eu'
}

export interface Tenant {
    admin?: boolean;
    adminUser?: User;
    anm?: boolean;
    blocked: boolean;
    configured: boolean;
    dateAdded?: Date | string;
    dateCreated: Date | string;
    dateUpdated: Date | string;
    domains: string[];
    id: string;
    identityTenantDomain: string | null;
    identityTenantId: string;
    identityTenantName: string;
    identityTenantType: string;
    internal?: boolean;
    internalId: string | null;
    name: string;
    partner: boolean;
    partnerTenant?: Tenant | object;
    region: Region;
    serialId: number | string;
    settings?: TenantSettings;
    subscriptionChannel?: SubscriptionChannel;
    type: string;
    userCount?: number;
}

export interface TenantFilters {
    global?: boolean;
    createWorkato?: boolean;
    excludePartner?: boolean;
    includePartnerDetails?: boolean;
    includeUserCount?: boolean;
    includeSettings?: boolean;
    includeAdmin?: boolean;
    partnerUpdate?: boolean;
    excludeDisabled?: boolean;
    trial?: boolean;
    setReprocessLogs?: boolean;
    providerType?: string;
}

export interface TenantStat {
    data: unknown[] | null;
    dateUpdated: Date | string;
    day: {
        [k: string]: unknown;
    };
    id: string;
    key: string;
    platformTenantId: string;
    value: number;
}
